import React, { useState } from "react";
import { DarkModeToggle } from "./toggleButtons";
import { ChatHistory } from "../pages/BackuHistory";




 export const Header= ({active, setActive, darkMode, setDarkMode, setManualScroll})=>{
    const [login, setLogin] = useState(false);
  
  
  return (
    <div
      id="header"
      className=" fixed right-0 left-0 z-20 top-0   hidden md:flex flex-nowrap justify-between p-1 sm:p-3 md:p-6 lg:p-10 items-center "
    >
      <div className=" sm:text-base  md:text-xl lg:text-2xl xl:text-3xl   font-extrabold ">
        <button onDoubleClick={() => setLogin(true)}>Y.Ichiba</button>
        {login && <ChatHistory />}
      </div>
      <div
        className={` font-serif text-gray-600 sm:text-base md:text-xl lg:text-2xl  space-x-2 sm:space-x-3 md:space-x-6 lg:space-x-9`}
      >
        <a
          href="#Profile"
          onClick={() => {
            setManualScroll(true);
            setActive("profile");
          }}
          className={`${
            active === "profile" &&
            `border-b-2 border-red-400 pb-1   ${
              darkMode ? "text-white" : "text-black"
            }`
          } `}
        >
          Profile
        </a>
        <a
          href="#Projects"
          onClick={() => {
            setManualScroll(true);
            setActive("project");
          }}
          className={`${
            active === "project" &&
            `border-b-2 border-red-400 pb-1   ${
              darkMode ? "text-white" : "text-black"
            }`
          } `}
        >
          Projects
        </a>
        <a
          href="#Contact"
          onClick={() => {
            setManualScroll(true);
            setActive("contact");
          }}
          className={`${
            active === "contact" &&
            `border-b-2 border-red-400 pb-1   ${
              darkMode ? "text-white" : "text-black"
            }`
          } `}
        >
          Contact
        </a>
        <DarkModeToggle darkMode={darkMode} setDarkMode={setDarkMode} />
      </div>
    </div>
  );
}



